import { Component, Input } from '@angular/core';

@Component({
  selector: 'vi-no-results',
  templateUrl: './no-results.component.html',
  styleUrls: ['./no-results.component.scss'],
})
export class ViNoResultsComponent {
  @Input()
  imgPath: string;
}
